/**
 * Created by theodora on 6/12/14.
 */

'use strict';

const { getBuyerId } = require('dibs-cookie-jar');
const authModalLoader = require('./AuthModalLoader').default;
const { getPasswordToken } = require('../authModal/authentication/userStoragePasswordToken');

const authModals = [
    authModalLoader.constants.LOGIN,
    authModalLoader.constants.REGISTER,
    authModalLoader.constants.RESET_PASSWORD,
    authModalLoader.constants.RESET_INVALID,
];

/**
 *
 * @param uri
 * @returns {string}
 */
function getRedirectDestination() {
    let dest = new URLSearchParams(window.location.search).get('ep');
    if (dest && dest.indexOf('//') > -1) {
        // id ep contains '//' then redirect to current page
        // if phishing is happening, just redirect to the homepage (uri.path = '/')
        dest = window.location.href;
    }

    return dest;
}

function isValidAction(action) {
    if (action === authModalLoader.constants.RESET_PASSWORD && !getPasswordToken()) {
        return false;
    }

    return action && authModals.indexOf(action) > -1;
}

module.exports = {
    /**
     * Changed window object to parameter for easier testing
     * @param {object} win Mock window object
     * @param {object} uri Mock object mainly for testing
     */
    init: function checkForAuthModal() {
        const destination = getRedirectDestination();
        let action = new URLSearchParams(window.location.search).get('modal') || '';
        const gaAction = action.replace('_', ' ');
        action = action.replace('_', '-');
        const authOptions = {
            action: action,
            ga: {
                label: gaAction + ' query param - address bar',
                value: window.scrollY ? 1 : 0,
            },
        };

        if (isValidAction(action)) {
            // Need to make sure we have fresh user state
            // and don't get into infinite redirect loops
            if (getBuyerId(document.cookie) && destination) {
                window.location.href = destination;
            } else {
                authModalLoader.show(authOptions).then(function authModalShowHandler(authResponse) {
                    if (destination && !authResponse.err) {
                        window.location.href = destination;
                    }
                });
            }
        }
    },
};
